import PropTypes from 'prop-types'
import { Navigate, useParams } from 'react-router-dom'

/**
 * Send an address of the old comms app to the same page in Comms V2.
 *
 * A `<Navigate replace>`, so the old address leaves no history entry, and a
 * redirect rather than a second copy of the page: the target route's own
 * role check then decides who may open it.
 *
 * @param {string|function} to  the V2 path, or a function of the old
 *     route's params returning it
 */
const LegacyRedirect = ({ to }) => {
    const params = useParams()
    return <Navigate replace to={typeof to === 'function' ? to(params) : to} />
}

LegacyRedirect.propTypes = {
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
}

export default LegacyRedirect
